import { Component, OnInit, ViewChild } from '@angular/core';
import { CalendarService } from 'src/app/services/calendar.service';
import { GlobalService } from 'src/app/services/global.service';
import { Calendar } from '@fullcalendar/core';

import interactionPlugin from '@fullcalendar/interaction'; // for selectable
import dayGridPlugin from '@fullcalendar/daygrid' // for dayGrid view
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { AddeventComponent } from 'src/app/popup/addevent/addevent.component';
import { ActivityService } from 'src/app/services/activity.service';
import { OpenfolderComponent } from 'src/app/popup/openfolder/openfolder.component';
import { AcitivitypopupComponent } from 'src/app/popup/acitivitypopup/acitivitypopup.component';
import { StoreactivityComponent } from 'src/app/popup/storeactivity/storeactivity.component';
import { StuckactivityComponent } from 'src/app/popup/stuckactivity/stuckactivity.component';

@Component({
  selector: 'app-fullcalendar',
  templateUrl: './fullcalendar.component.html',
  styleUrls: ['./fullcalendar.component.css']
})
export class FullcalendarComponent implements OnInit {

  //string
  token: string;
  title = 'calendar';
  calendarPlugins = [dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin];
  calendarEvents = []
  header = {
    locales: 'it',
    left: 'prev,next today',
    center: 'title',
    right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
  }
  buttonText = {
    today: 'Oggi',
    month: 'Mese',
    week: 'Settimana',
    day: 'Giornata',
    list: 'lista'
  }

  constructor(
    private globals: GlobalService,
    private calendarService: CalendarService,
    private modalService: NgbModal,
  ) { }

  ngOnInit() {
    this.globals.checkPage(8);
    if (!this.token) {
      this.token = this.globals.getToken();
    }
    this.getEvent(); 
  }

  getEvent() {
    this.calendarService.getEvents(this.token).subscribe(
      res => {
        res.forEach((event) => {
          this.colorSelector(event);
          if(event.allday == 'Y'){
            event.allday = true;
          } else {
            event.allday = false;
          }
          this.calendarEvents = this.calendarEvents.concat([
            { 
              title: event.json ? `${event.json.customer.view_name} - ${event.calendar_name}` : event.calendar_name,
              start: event.start_date,
              end: event.end_date,
              allDay: event.allday,
              backgroundColor: event.backgroundColor ? event.backgroundColor : null,
              borderColor: event.borderColor ? event.borderColor : null,
              extendedProps: {
                calendar_id: event.calendar_id,
                instance_id: event.instance_id,
                customer_id: event.customer_id,
                state: event.state,
                info: event.json,
              }
            }
          ]);
        });
        console.log("Eventi ricevuti: ", res);
        console.log("Eventi a calendario: ", this.calendarEvents);
      },
      err => {
        console.error("errore in getEvent: ", err);
      }
    )
  }

  colorSelector(event){
    if(event.state){
      if (event.state == 'Chiuso'){
        event.backgroundColor = 'gray';
        event.borderColor = 'black';
      }

      if (event.state == 'Test'){
        event.backgroundColor = 'red';
        event.borderColor = 'gray';

      }

      if (event.state == 'Bloccato'){
        event.backgroundColor = 'yellow';
        event.borderColor = 'gray';
      }

      if (event.state == 'In attesa'){
        event.backgroundColor = 'green';
        event.borderColor = 'gray';

      }
    }
  }

  handleSelect(arg) {
    // if (confirm('Would you like to add an event to ' + arg.dateStr + ' ?')) {
    //   this.calendarEvents = this.calendarEvents.concat({ // add new event data. must create new array
    //     title: 'New Event',
    //     start: arg.date,
    //     allDay: arg.allDay
    //   })
    // }
    
    let dateEnd = new Date(arg.endStr)
    let dateStart = new Date(arg.startStr);
    
    console.log(arg);
    console.log(dateStart.getDate());
    console.log(dateEnd.getDate() - 1);

    if (dateStart.getDate() == dateEnd.getDate() - 1) {
      const modalRef = this.modalService.open(AddeventComponent, { backdrop: 'static', centered: true, size: 'xl' });
      modalRef.componentInstance.start = dateStart;
      modalRef.result.then(result => {
        console.log(result);
      });
    }

    if (dateStart.getDate() != dateEnd.getDate() - 1) {
      dateEnd = this.globals.cleanDate(dateEnd);
      const modalRef = this.modalService.open(AddeventComponent, { backdrop: 'static', centered: true, size: 'xl' });
      modalRef.componentInstance.start = dateStart;
      modalRef.componentInstance.end = dateEnd;
      modalRef.result.then(result => {
        console.log(result);
      });
    }

  }

  eventClick(info) {
    console.log(info);
    if(info.event.extendedProps.info && info.event.extendedProps.state == 'In attesa' ){
      let ele = info.event.extendedProps.info
      // console.log(ele.pop_up);
      const modalRef = this.modalService.open(AcitivitypopupComponent, { backdrop: 'static', centered: true, size: 'xl' });
      modalRef.componentInstance.activityName = ele.pop_up;
      modalRef.componentInstance.info = ele;
      modalRef.componentInstance.process = {procces_id: info.event.extendedProps.procces_id, instance_id: info.event.extendedProps.instance_id};
      modalRef.result.then((result) => {
        if (result != 'cancel') {
          this.calendarEvents = [];
          setTimeout(() => {
            this.getEvent();
          }, 1000);
        }
      }, reason => {
      })
    } else {
      if(!info.event.extendedProps.state || info.event.extendedProps.state == 'Chiuso'){
        let calendar_id = info.event.extendedProps.calendar_id;
        const modalRef = this.modalService.open(StoreactivityComponent,  {backdrop: 'static', centered: true, size: 'xl'});
        modalRef.componentInstance.calendar_id = calendar_id;
        modalRef.result.then((result) => {
          if(result != 'cancel'){
            this.calendarEvents = [];
            setTimeout(() => {
              this.getEvent();
            }, 250);
          }
        }, reason => {
  
        })
      }
      if(info.event.extendedProps.state && info.event.extendedProps.state == 'Bloccato'){
        let calendar_id = info.event.extendedProps.calendar_id;
        const modalRef = this.modalService.open(StuckactivityComponent,  {backdrop: 'static', centered: true, size: 'xl'});
        // modalRef.componentInstance.calendar_id = calendar_id;
        modalRef.result.then((result) => {
          if(result != 'cancel'){
            this.calendarEvents = [];
            setTimeout(() => {
              this.getEvent();
            }, 250);
          }
        }, reason => {
        })
      }
    }
    
  }

  modifyTitle(eventIndex, newTitle) {
    let calendarEvents = this.calendarEvents.slice(); // a clone
    let singleEvent = Object.assign({}, calendarEvents[eventIndex]); // a clone
    singleEvent.title = newTitle;
    calendarEvents[eventIndex] = singleEvent;
    this.calendarEvents = calendarEvents; // reassign the array
  }

}